import React, { useEffect, useCallback, useRef, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import noImage from 'images/no_image.png'

const Image = ({ showMenu }) => {
  if(window.currentUser.photo) {
    return <img className='pull-right rounded-circle user-profile-image rounded-circle' height="80" onClick={showMenu} src={window.currentUser.photo} alt='' />
  } else {
    return <img className='pull-right rounded-circle user-profile-image rounded-circle' height="80" onClick={showMenu} src={noImage} alt='' />
  }
}

const HeaderMenu = ({ 
  peerToPeerWizardIsAvailable, 
  userRegistrationStatus 
}) => {
  const ref = useRef(null)
  const params = useParams()
  const { token } = params
  const [ showMenu, setShowMenu ] = useState(false)

  const handleOutsideClick = useCallback((e) => {
    if (ref.current && !ref.current.contains(e.target)){
      setShowMenu(false)
    }
  },[ref])

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick)
    
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [])
  
  const userTitle = () => {
    if(window.currentUser.title){
      return window.currentUser.title.length > 25 ? `${window.currentUser.title.substring(0, 25)}...` : `${window.currentUser.title}`
    }else{
      return ''
    }
  }
  
  const toggleMenu = useCallback(() => setShowMenu(!showMenu), [showMenu])

  return(
    <div>
      <Image showMenu={toggleMenu} />
      { showMenu && (
        <div
          className='menu'
          ref={ref}
        >
          <h4 className='menu-name'>{ window.currentUser.first_name } { window.currentUser.last_name }</h4>
          <h5 className='menu-title'>{ userTitle }</h5>
          <hr/>
          <h5 className='menu-subheader'>AGENDA</h5>
          <ul>
            <li className='menu-item'>
              <Link
                to={{
                  pathname: '/' + token,
                  state: { agendaFilters: { mySchedule: false }}
                }}
              >
                FULL AGENDA
              </Link>
            </li>
            <li className='menu-item'>
              <Link
                to={{
                  pathname: '/' + token,
                  state: { agendaFilters: { mySchedule: true }}
                }}
              >
                MY SCHEDULE
              </Link>
            </li>
          </ul>
          <div>
            <hr/>
            <h5 className='menu-subheader'>MEETING PROFILE</h5>
            <ul>
              <li className='menu-item'>
                <Link to={'/' + token + '/profile'}>
                  MY DETAILS
                </Link>
              </li>
            </ul>
          </div>
          { ['registration_status_approved'].indexOf(userRegistrationStatus) >= 0 && peerToPeerWizardIsAvailable &&
            <div>
              <ul>
                <li className='menu-item'>
                  <Link to={'/' + token + '/wishlist'}>
                    MY PREFERENCES
                  </Link>
                </li>
                <li className='menu-item'>
                  <Link to={'/' + token + '/wishlist_rank'}>
                    RANK PREFERENCES
                  </Link>
                </li>
                <li className='menu-item'>
                  <Link to={'/' + token + '/availability'}>
                    AVAILABLITY
                  </Link>
                </li>
              </ul>
            </div>
          }
        </div>
      ) }
    </div>
  )
}

export default HeaderMenu
